import { C } from '../../Dashboard/components/dashboardConstants';

export function IcoChevronRight() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M9 18l6-6-6-6" stroke={C.g300} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IcoSearch() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="11" cy="11" r="7" stroke={C.g300} strokeWidth="1.5"/>
      <path d="M16.5 16.5L21 21" stroke={C.g300} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

export function IcoFilter() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path d="M3 6h18M7 12h10M11 18h2" stroke={C.g400} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

export function IcoChevronDown() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path d="M6 9l6 6 6-6" stroke={C.g400} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IcoCalSm() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="4" width="18" height="18" rx="2" stroke={C.sub} strokeWidth="1.5"/>
      <path d="M16 2v4M8 2v4M3 10h18" stroke={C.sub} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}
